import React, { useState } from "react";
import {
    Button, FormControl, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,TableContainer,
      Paper,
    TableCell,
    Typography,
    Avatar,
    Chip,
    Collapse,
    InputAdornment,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import ProgressKeyButtons from "../../components/ProgressKeyButtons/ProgressKeyButtons";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import TeacherService from "./Locality/Service/teacherService";
import {
  getTeacherAssignedClasses,
  filterSectionsForAssignedClass,
} from "../../utils/teacherAssignments";
import {  Card, Box } from "@material-ui/core";
import StudentService from "./Locality/Service/studentService"
import MovableService from "./Locality/Service/movablesService";
import MovableMasterService from "./Locality/Service/movableMasterService";
import * as Yup from 'yup';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import FilterListIcon from '@material-ui/icons/FilterList';
import CloseIcon from '@material-ui/icons/Close';
import SchoolIcon from '@material-ui/icons/School';
import PersonIcon from '@material-ui/icons/Person';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { makeStyles } from '@material-ui/core/styles';
import FilterPanel, { FilterSection } from '../../components/ui/FilterPanel';
import LanguageSoundHeader from "../../components/LanguageSoundHeader";
import TablePagination from "@material-ui/core/TablePagination";
import { DEFAULT_MOVABLES } from "../../utils/languageDefaults";
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    tableOverflow: {
        overflowX: "auto",
    },
    pageHeader: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    pageTitle: {
        fontWeight: 700,
        fontSize: '1.9rem',
        color: '#1a1a1a',
        lineHeight: 1.2,
    },
    pageSubtitle: {
        color: '#555',
        fontSize: '0.9rem',
        marginTop: 2,
    },
    noteBanner: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        borderRadius: 12,
        backgroundColor: '#e6e6e6',
        border: '1px solid #d6e4ff',
        marginBottom: theme.spacing(2),
    },
    noteIconWrap: {
        width: 28,
        height: 28,
        borderRadius: '50%',
        backgroundColor: '#1a1a1a',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    filtersCard: {
        borderRadius: 14,
        border: '1px solid #d9d9d9',
        boxShadow: 'none',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    filtersRow: {
        display: 'flex',
        alignItems: 'flex-end',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        width: '100%',
    },
    filtersChip: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        height: 40,
        boxSizing: 'border-box',
        padding: '0 12px',
        borderRadius: 8,
        border: '1px solid #8f8f8f',
        backgroundColor: '#fff',
        cursor: 'pointer',
        fontWeight: 600,
        color: '#1a1a1a',
        userSelect: 'none',
        flexShrink: 0,
    },
    countBadge: {
        backgroundColor: '#fff',
        color: '#1a1a1a',
        border: '1px solid #c4c4c4',
        borderRadius: 12,
        padding: '1px 10px',
        fontSize: '0.72rem',
        fontWeight: 700,
        marginLeft: 8,
    },
    fieldLabel: {
        fontSize: '0.78rem',
        fontWeight: 600,
        color: '#444',
        marginBottom: 6,
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        minHeight: 18,
        lineHeight: '18px',
    },
    resetBtn: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 8,
        color: '#444',
        border: '1px solid #8f8f8f',
        height: 40,
        minWidth: 88,
        padding: '0 16px',
    },
    filterFieldWrap: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 0',
        minWidth: 150,
    },
    filterActionsWrap: {
        display: 'flex',
        flexDirection: 'column',
        flex: '0 0 auto',
        justifyContent: 'flex-end',
    },
    tableCard: {
        borderRadius: 14,
        border: '1px solid #d9d9d9',
        boxShadow: 'none',
        overflow: 'hidden',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2),
    },
    iconBtnOutlined: {
        border: '1px solid #8f8f8f',
        borderRadius: 8,
        padding: 8,
        color: '#444',
    },
    studentAvatar: {
        width: 30,
        height: 30,
        backgroundColor: '#e6e6e6',
        color: '#1a1a1a',
        fontSize: '0.85rem',
    },
    stickyNameHead: {
        position: 'sticky',
        left: 0,
        zIndex: 5,
        backgroundColor: '#efefef',
        color: '#444',
        fontWeight: 700,
        fontSize: '0.8rem',
        borderBottom: '1px solid #d9d9d9',
        borderRight: '1px solid #d9d9d9',
        minWidth: 200,
    },
    stickyNameCell: {
        position: 'sticky',
        left: 0,
        zIndex: 3,
        backgroundColor: '#fff',
        borderRight: '1px solid #d9d9d9',
        minWidth: 200,
    },
    soundHead: {
        backgroundColor: '#efefef',
        color: '#444',
        fontWeight: 700,
        fontSize: '0.8rem',
        borderBottom: '1px solid #d9d9d9',
        textAlign: 'center',
    },
    soundLabel: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 24,
        height: 24,
        padding: '0 6px',
        borderRadius: 6,
        backgroundColor: '#e6e6e6',
        color: '#1a1a1a',
        fontWeight: 700,
        textTransform: 'uppercase',
    },
}));
export default function Movable() {

//  const tableHeaders = ["Student Name",
//     'Vowel-1', 'Vowel-2',	'Vowel-3',	'j', 'e', 'sh',	'ch', 'th',	'ng', 'oo',  'ee',	'oo', 'a-e', 'i-e',	'o-e', 	'u-e (1)',	'u-e (2)', 'le',
//     	'qu',	'ssggll',	'Hp -vowel', 'Hp-Const', 'Hg-Vowel', 'Hg-Const'
// ];
// const movable = [
//     'Vowel-1', 'Vowel-2',	'Vowel-3',	'j', 'e', 'sh',	'ch', 'th',	'ng', 'oo',  'ee',	'oo', 'a-e', 'i-e',	'o-e', 	'u-e (1)',	'u-e (2)', 'le',
//     	'qu',	'ssggll',	'Hp -vowel', 'Hp-Const', 'Hg-Vowel', 'Hg-Const'
//   ];

    const classes = useStyles();
    const userDetails = JSON.parse(localStorage.getItem("userDetail") || "{}");
    const isTeacher = String(userDetails.role || "").toUpperCase() === "TEACHER";
    const [movable ,setmovable] =  useState([]);
    const [tableHeaders, setTableHeaders] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [listClassId, setListClassId] = useState("");
    const [listSectionId, setListSectionId] = useState("");
    const [listSectionList, setListSectionList] = useState([]);
    const [teacherHasMultipleClasses, setTeacherHasMultipleClasses] = useState(false);
    const [assignedClassList, setAssignedClassList] = useState([]);
    // ---- Redesigned UI state ----
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [movableList, setMovableList] = useState([]);
    const [formData, setFormData] = useState("");
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    var [uploadError, setUploadError] = useState({ isShowError: false, successCount: 0, error: [], message: "" });
    const [open, setOpen] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(5);
    const current = new Date();
    var [classId, setClassId] = useState("");
    const date = `${current.getFullYear()}-0${current.getMonth() + 1}-${current.getDate()}`;
    var [dateValue, setDateValue] = useState(date);
    // const [movable, setMovable] = useState({
    //     classId:'',
    //     movable: '',
      
    //     studentId: '',
    // });
 
    const validationSchema = Yup.object().shape({
        classId: Yup.string().required('Class Name is required'),
        studentId: Yup.string().required('Student Name is required'),
        movable: Yup.string().required('movable is required'),
    });
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    const effectiveClassId = listClassId || userDetails.classId || "";
    const effectiveSectionId = listSectionId || userDetails.sectionId || "";

    const loadListSectionList = (classId) => {
        if (!classId) {
            setListSectionList([]);
            return;
        }
        SectionService.findSectionList({
            schooleId: userDetails.schooleId,
            classId,
        })
            .then((res) => {
                const sections = Array.isArray(res) ? res : [];
                setListSectionList(
                    filterSectionsForAssignedClass(assignedClassList, classId, sections)
                );
            })
            .catch(() => setListSectionList([]));
    };

    const classOptions =
        userDetails.role === "TEACHER" && assignedClassList.length
            ? assignedClassList
            : addClassList;
    const classSelectEnabled =
        userDetails.role !== "TEACHER" || classOptions.length > 1;
    const sectionSelectEnabled = Boolean(listClassId);

    const onListClassChange = (e) => {
        const id = e.target.value;
        setListClassId(id);
        setListSectionId("");
        loadListSectionList(id);
    };

    const onListSectionChange = (e) => {
        setListSectionId(e.target.value);
    };

    // Fetch movable alphabets list from MovableMaster API and combine with existing student data
    const getMovableAlphabetsList = () => {
        const body = {
            schooleId: userDetails.schooleId || "",
            classId: effectiveClassId || "",
        };

        MovableMasterService.findMovableMasterList(body)
            .then((res) => {
                // Extract unique movable alphabet names from MovableMaster
                const masterMovableNames = [...new Set(
                    res
                        .map(item => item.name)
                        .filter(name => name) // Remove empty/null names
                )];
                
                // Get existing movable alphabets from students
                const getExistingStudentMovables = () => {
                    const getSpeList = { classId: effectiveClassId };
                    if (effectiveSectionId) getSpeList.sectionId = effectiveSectionId;
                    return StudentService.getAllStudentById(userDetails.schooleId, getSpeList)
                        .then((studentRes) => {
                            // Collect all movable keys from all students
                            const allStudentMovables = new Set();
                            studentRes.forEach((student) => {
                                if (student.movable && typeof student.movable === 'object') {
                                    Object.keys(student.movable).forEach(key => {
                                        if (key) allStudentMovables.add(key);
                                    });
                                }
                            });
                            return Array.from(allStudentMovables);
                        })
                        .catch((err) => {
                            console.error("Error fetching existing student movables:", err);
                            return [];
                        });
                };

                // Combine master movables with existing student movables
                getExistingStudentMovables().then((existingMovables) => {
                    // Merge both arrays and remove duplicates
                    const combinedMovables = [...new Set([...masterMovableNames, ...existingMovables])];
                    
                    // Sort movables alphabetically
                    combinedMovables.sort();

                    const finalMovables = combinedMovables.length ? combinedMovables : DEFAULT_MOVABLES;
                    setmovable(finalMovables);
                    // Update table headers dynamically
                    setTableHeaders(["Student Name", ...finalMovables]);
                });
            })
            .catch((err) => {
                console.error("Error fetching movable alphabets list:", err);
                // Fallback: get existing movables from students
                const getSpeList = { classId: effectiveClassId };
                if (effectiveSectionId) getSpeList.sectionId = effectiveSectionId;
                StudentService.getAllStudentById(userDetails.schooleId, getSpeList)
                    .then((studentRes) => {
                        const allStudentMovables = new Set();
                        studentRes.forEach((student) => {
                            if (student.movable && typeof student.movable === 'object') {
                                Object.keys(student.movable).forEach(key => {
                                    if (key) allStudentMovables.add(key);
                                });
                            }
                        });
                        const existingMovables = Array.from(allStudentMovables).sort();
                        const finalMovables = existingMovables.length ? existingMovables : DEFAULT_MOVABLES;
                        setmovable(finalMovables);
                        setTableHeaders(["Student Name", ...finalMovables]);
                    })
                    .catch((studentErr) => {
                        setmovable(DEFAULT_MOVABLES);
                        setTableHeaders(["Student Name", ...DEFAULT_MOVABLES]);
                    });
            });
    };

    useEffect(() => {
        if (!userDetails.schooleId) return;
        if (userDetails.role === "TEACHER" && userDetails.teacherId) {
            TeacherService.getTeacherById(userDetails.teacherId)
                .then((teacher) => {
                    const assigned = getTeacherAssignedClasses(teacher);
                    setAssignedClassList(assigned);
                    setTeacherHasMultipleClasses(assigned.length > 1);
                    const primaryAssigned = assigned.find(
                        (cls) => String(cls.className || "").trim().toLowerCase() === "primary"
                    );
                    const defaultClassId =
                        primaryAssigned?._id || userDetails.classId || assigned[0]?._id || "";
                    const defaultSectionId =
                        defaultClassId === String(userDetails.classId || "")
                            ? (userDetails.sectionId || "")
                            : "";
                    setListClassId(defaultClassId);
                    setListSectionId(defaultSectionId);
                    if (defaultClassId) {
                        SectionService.findSectionList({
                            schooleId: userDetails.schooleId,
                            classId: defaultClassId,
                        })
                            .then((secRes) => {
                                setListSectionList(
                                    filterSectionsForAssignedClass(
                                        assigned,
                                        defaultClassId,
                                        Array.isArray(secRes) ? secRes : []
                                    )
                                );
                            })
                            .catch(() => setListSectionList([]));
                    }
                })
                .catch(() => {
                    setTeacherHasMultipleClasses(false);
                    setAssignedClassList([]);
                });
            return;
        }
        AddClassService.getAllAddClass(userDetails.schooleId)
            .then((res) => setAddClassList(Array.isArray(res) ? res : []))
            .catch(() => setAddClassList([]));
        setTeacherHasMultipleClasses(true);
    }, []);

    useEffect(() => {
        if (listClassId) {
            loadListSectionList(listClassId);
        }
    }, [listClassId, assignedClassList]);

    useEffect(() => {
        if (userDetails.schooleId && effectiveClassId) {
            getMovableAlphabetsList();
        }
    }, [effectiveClassId, effectiveSectionId]);

    useEffect(() => {
        // Load students whenever the class/section changes, even if no movable
        // columns exist yet (e.g. schools without movable master records).
        if (userDetails.schooleId && effectiveClassId) {
            getStudentList();
        }
        return () => {
            setStudentList([]);
        }
    }, [movable, effectiveClassId, effectiveSectionId]);
    const getMovableList = () => {
        MovableService.getAllMovable().then((res) => {
            setMovableList(res);
        }).catch((err) => {
            setError(err.message);
        });
    }
    const handleOpen = () => {
        setOpen(true);
    };
    const handleOpen1 = () => {
        setOpen1(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleClose1 = () => {
        setOpen1(false);
    };
    const getAddClassList = (event) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            let list = Array.isArray(res) ? res : [];
            if (userDetails.role === "TEACHER" && assignedClassList.length) {
                const allowed = new Set(assignedClassList.map((c) => String(c._id)));
                list = list.filter((cls) => allowed.has(String(cls._id)));
            }
            setAddClassList(list);
            if (userDetails.classId) {
                setClassId(userDetails.classId);
                getStudentList({ target: { value: userDetails.classId } });
              } else {
                setClassId(""); // No default selection
              }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    

    // const deleteSpecialObservation = (observationdelete) => {
    //     if (observationdelete) {
    //         SpecialObservationService.deleteSpecialobservation(observationdelete).then((res) => {
    //             getSpecialObservationList();
    //         }).catch((err) => {
    //         });
    //     }
    // };
 
    const deleteMovable = (movabledelete) => {
        if (movabledelete) {
            MovableService.deleteMovable(movabledelete).then((res) => {

               getMovableList()
            }).catch((err) => {
            });
        }
    }
    const handleChangeImage = (evt) => {
        console.log("Uploading");
        var file = evt.target.files[0];
        let data = new FormData();
        data.append('image', file);
        setFormData(data)
        console.log("Uploaded");
    }

    const getStudentList = (event, obj) => {
        const getSpeList = { classId: effectiveClassId };
        if (effectiveSectionId) getSpeList.sectionId = effectiveSectionId;
        StudentService.getAllStudentById(userDetails.schooleId, getSpeList)
            .then((res) => {
                const studentDetails = res.map((student) => {
                    // Ensure each student has a movable object; initialize if missing
                    const movablesObj = student.movable || {};
                    // Initialize all movable alphabets (from master + existing) as unchecked if not present
                    movable.forEach((movableKey) => {
                        if (!(movableKey in movablesObj)) {
                            movablesObj[movableKey] = "";
                        }
                    });
                    return {
                        _id: student._id,
                        studentName: `${student.firstName} ${student.lastName}`,
                        movable: movablesObj,
                    };
                });
                
                setStudentList(studentDetails);
            })
            .catch((err) => {
                console.error("Error fetching student list:", err);
            });
    }

    const formik = useFormik({
        initialValues: {},
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            if (movable._id) {
                MovableService.upadeMovable(values).then((res) => {
                    handleClose();
                    getMovableList();
                    resetForm()
                    alert(" Movable Alphabets Updated Successfully.");
                }).catch((err) => {
                });
            }
            else {
                
                MovableService.creteMovable(values).then((res) => {
                    getMovableList();
                    resetForm();
                    handleClose();
                    alert(" Movable Alphabets Added Successfully.");
                })
                    .catch((err) => {
                        alert(err.response.data.message)
                    })
            }

        },
    });
    const handleProgressChange = (student, movableKey, progressKey) => {
        const movablesObj = { ...student.movable };
        movable.forEach((movableItem) => {
          if (!(movableItem in movablesObj)) {
            movablesObj[movableItem] = "";
          }
        });
        movablesObj[movableKey] = progressKey || "";
        
        // Update the student's movable locally
        const updatedStudent = {
          ...student,
          movable: movablesObj,
        };
        
        // Update the student list state immediately for better UX
        const updatedList = studentList.map((s) =>
          s._id === student._id ? updatedStudent : s
        );
        setStudentList(updatedList);
    
        // Call API to update the student
        StudentService.updateLanguageProgress(student._id, { movable: movablesObj })
          .then((res) => {
            // Don't refetch immediately - keep the local state
            // The state is already updated above, so no need to refetch
            console.log("Student movable updated successfully");
          })
          .catch((err) => {
            console.error(err.response?.data?.message || "Error updating student");
            // On error, revert the local state by refetching
            getStudentList();
          });
      };
    
    const onSubmit = data => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const keys = {  "schooleId": userDetails.schooleId, "studentList": studentList, "teacherId": userDetails._id,
         "date": dateValue
         }
         MovableService.creteMovable(keys).then((res) => {
            setDateValue("");
            setStudentList([]);
            alert(" Attendence Successfully.");
        }).catch((err) => {

            alert(err.response.data.message);
        });
    };
    const filteredStudents = studentList.filter((s) =>
        (s.studentName || "").toLowerCase().includes(searchTerm.toLowerCase())
    );
    const activeFilterCount = [listClassId, listSectionId].filter(Boolean).length;
    const handleResetFilters = () => {
        setListClassId("");
        setListSectionId("");
        setSearchTerm("");
        setpg(0);
    };

    return (
        <>
            {/* Page header */}
            <Box className={classes.pageHeader}>
                <Box>
                    <Typography className={classes.pageTitle}>Movable Alphabets</Typography>
                    <Typography className={classes.pageSubtitle}>
                        Track each student's movable alphabet progress using P, WA, WI, and M.
                    </Typography>
                </Box>
            </Box>


            <Card className={classes.tableCard} elevation={0}>
                <Box className={classes.toolbar}>
                    <Box display="flex" alignItems="center" gridGap={10} flexWrap="wrap">
                        <Typography variant="body2" style={{ color: '#444', fontWeight: 600 }}>
                            {filteredStudents.length} {filteredStudents.length === 1 ? 'Student' : 'Students'}
                        </Typography>
                        <Chip size="small" label={`${movable.length} Alphabets`} style={{ backgroundColor: '#e6e6e6', color: '#1a1a1a', fontWeight: 600 }} />
                    </Box>
                    <Box display="flex" alignItems="center" gridGap={10} flexWrap="wrap">
                        <TextField
                            size="small"
                            variant="outlined"
                            placeholder="Search by student name..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ minWidth: 240 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" style={{ color: '#8a8a8a' }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Button
                          variant="outlined"
                          startIcon={<FilterListIcon fontSize="small" />}
                          onClick={() => setFiltersOpen((o) => !o)}
                          aria-pressed={filtersOpen}
                          style={filtersOpen ? { backgroundColor: '#e6e6e6' } : undefined}
                        >
                          Filters
                          {activeFilterCount > 0 && <span className={classes.countBadge}>{activeFilterCount}</span>}
                        </Button>
                        <Tooltip title="Refresh">
                            <span>
                                <IconButton
                                    className={classes.iconBtnOutlined}
                                    onClick={() => getMovableAlphabetsList()}
                                    disabled={!effectiveClassId}
                                >
                                    <RefreshIcon fontSize="small" />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Box>
                </Box>

                <Box display="flex" alignItems="stretch" flexWrap="wrap">
                <Box flex="1 1 520px" minWidth={0}>
                <TableContainer component={Paper} elevation={0} className={classes.tableOverflow} style={{ maxHeight: 540 }}>
          <Table stickyHeader className="mb-0">
            <TableHead>
              <TableRow>
                <TableCell className={classes.stickyNameHead}>Student Name</TableCell>
                {movable.map((key) => (
                  <TableCell key={key} className={classes.soundHead}>
                    <LanguageSoundHeader
                      code={key}
                      isTeacher={isTeacher}
                      className={classes.soundLabel}
                    />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredStudents.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={movable.length + 1} align="center" style={{ padding: 36, color: '#8a8a8a' }}>
                    {effectiveClassId ? 'No students found.' : 'Select a class to load students.'}
                  </TableCell>
                </TableRow>
              ) : (
                filteredStudents
                  .slice(pg * rpg, pg * rpg + rpg)
                  .map((student) => (
                    <TableRow key={student._id} hover>
                      <TableCell className={classes.stickyNameCell}>
                        <Box display="flex" alignItems="center" gridGap={10}>
                          <Avatar className={classes.studentAvatar}>
                            {(student.studentName || '?').charAt(0).toUpperCase()}
                          </Avatar>
                          <span style={{ fontWeight: 600, color: '#1a1a1a' }}>{student.studentName}</span>
                        </Box>
                      </TableCell>
                      {movable.map((key) => (
                        <TableCell key={key} align="center" style={{ padding: '4px 4px', minWidth: 96 }}>
                          <ProgressKeyButtons
                            value={student.movable[key]}
                            onChange={(progressKey) => handleProgressChange(student, key, progressKey)}
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          rowsPerPageOptions={[5, 50, 100, 500, 1000]}
          count={filteredStudents.length}
          page={pg}
          onPageChange={handleChangePage}
          rowsPerPage={rpg}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
                </Box>
                {filtersOpen && (
                    <FilterPanel onReset={handleResetFilters}>
                    <FilterSection title="Class" icon={<SchoolIcon style={{ fontSize: 16 }} />}>
                            <FormControl fullWidth variant="outlined" size="small" disabled={!classSelectEnabled}>
                                <Select displayEmpty value={listClassId} onChange={onListClassChange}>
                                    <MenuItem value=""><em>All Classes</em></MenuItem>
                                    {classOptions.map(({ _id, className }) => (
                                        <MenuItem key={_id} value={_id}>{className}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                    </FilterSection>
                    <FilterSection title="Section" icon={<PersonIcon style={{ fontSize: 16 }} />}>
                            <FormControl fullWidth variant="outlined" size="small" disabled={!sectionSelectEnabled}>
                                <Select displayEmpty value={listSectionId} onChange={onListSectionChange}>
                                    <MenuItem value=""><em>All Sections</em></MenuItem>
                                    {listSectionList.map(({ _id, sectionName }) => (
                                        <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                    </FilterSection>
                    </FilterPanel>
                )}
                </Box>
            </Card>
        </>

    );
}


